<div class="inner-content">
  <ng-content></ng-content>
</div>
